
import { Component, Prop, Vue } from 'vue-property-decorator';
import Glide from '@glidejs/glide';
import '@glidejs/glide/dist/css/glide.core.min.css';
import '@glidejs/glide/dist/css/glide.theme.min.css';

@Component({
    name: 'GlideCarousel',
})
export default class GlideCarousel extends Vue {
    @Prop({ required: true, default: () => [] })
    private readonly images!: { src: string; alt?: string }[];

    @Prop({
        default: () => ({
            type: 'carousel',
            perView: 1,
            autoplay: 5000,
        }),
    })
    private readonly options!: Record<string, any>;

    private glideInstance: any = null;
    private currentIndex: number = this.options.startAt || 0;

    mounted() {
        this.glideInstance = new Glide(this.$el, this.options);
        this.glideInstance.on('run', () => {
            this.currentIndex = this.glideInstance.index;
        });
        this.glideInstance.mount();
    }

    goToSlide(index: number) {
        this.glideInstance.go(`=${index}`);
        this.currentIndex = index;
    }
}
